<template>
  <div>
    <v-dialog v-model="addDataDialog" persistent max-width="600">
      <v-card>
        <v-card-title class="text-h6 font-weight-bold">
          Tambah User Web
        </v-card-title>

        <v-divider class="mx-5"></v-divider>

        <v-card-text class="pb-0 mt-3">
          <v-form ref="form" v-model="valid">
            <v-card-title
              class="pa-0 text-subtitle-1 font-weight-bold black--text"
            >
              Nama
            </v-card-title>
            <v-text-field
              v-model="data.name"
              outlined
              dense
              :rules="[rules.required]"
              autocomplete="off"
            >
            </v-text-field>

            <v-card-title
              class="pa-0 text-subtitle-1 font-weight-bold black--text"
            >
              Email
            </v-card-title>
            <v-text-field
              v-model="data.email"
              dense
              outlined
              :rules="[rules.required, rules.email]"
              autocomplete="off"
            >
            </v-text-field>

            <v-card-title
              class="pa-0 text-subtitle-1 font-weight-bold black--text"
            >
              Password
            </v-card-title>
            <v-text-field
              v-model="data.passw"
              outlined
              dense
              :rules="[rules.required, rules.minReq]"
              autocomplete="off"
            >
            </v-text-field>

            <v-card-title
              class="pa-0 text-subtitle-1 font-weight-bold black--text"
            >
              Role
            </v-card-title>
            <v-select
              v-model="data.role_id"
              dense
              outlined
              :items="roleList"
              item-text="name"
              item-value="id"
              :rules="[rules.required]"
            >
            </v-select>

            <v-card-title
              class="pa-0 text-subtitle-1 font-weight-bold black--text"
            >
              Gudang
            </v-card-title>
            <v-select
              v-model="listGudang"
              dense
              outlined
              :items="gudangList"
              item-text="name"
              item-value="id"
              chips
              multiple
              :rules="[rules.select2]"
            >
            </v-select>
          </v-form>
        </v-card-text>

        <v-card-actions class="pb-5">
          <v-spacer></v-spacer>
          <v-btn
            outlined
            color="#61B15A"
            style="text-transform: unset !important"
            @click="closeAddData"
          >
            Batal
          </v-btn>
          <v-btn
            color="#61B15A"
            class="white--text"
            style="text-transform: unset !important"
            @click="checkEmail"
            :disabled="!valid"
            :loading="loading"
          >
            Simpan
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog persistent v-model="popDialog" width="500">
      <v-card color="red" rounded>
        <v-card-title class="text-h6 white--text">
          Data Gagal Ditambahkan !!
        </v-card-title>
        <v-card-title class="text-caption white--text">
          {{ popTitle }}
        </v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="light-green darken-1"
            class="white--text"
            @click="closePopDialog"
            >Tutup</v-btn
          >
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import axios from "axios";

export default {
  props: {
    addDataDialog: Boolean,
    roleList: Array,
    gudangList: Array,
  },
  data: () => ({
    valid: false,
    loading: false,
    popDialog: false,
    popTitle: "",
    data: {
      name: "",
      email: "",
      passw: "",
      role_id: "",
    },
    listGudang: [],
    managedGudang: [],
    rules: {
      required: (value) => !!value || "Tidak boleh kosong !!",
      select2: (value) =>  value.length>0 || "Item is required in select 2",
      minReq: (value) => value.length >= 6 || "Min 6 karakter",
      email: (value) => {
        const pattern =
          /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return pattern.test(value) || "e-mail tidak valid !!";
      },
    },
  }),
  methods: {
    checkEmail(){
      this.data.email = this.data.email.toLowerCase();
      this.loading = true;
      axios
        .get("v1/admin/user_web/email?email=" + this.data.email)
        .then(() => {
          this.popTitle = "Email sudah digunakan";
          this.popDialog = true;
        })
        .catch(() => {
          console.clear();
          this.save();
        });
    },
    save() {
      this.data.name = this.data.name.replace(/\b\w/g, (c) => c.toUpperCase());
      const dataSend = JSON.stringify(this.data);
      axios
        .post("v1/admin/user_web", dataSend, {
          headers: {
            "Content-Type": "application/json",
          },
        })
        .then((response) => {
          if (response.status === 200) {
            var put = {};
            put.id = response.data.data.genUID;
            put.list_gudang = this.listGudang;
            const putSend = JSON.stringify(put);
            axios
              .put("v1/admin/user_web/gudang", putSend, {
                headers: {
                  "Content-Type": "application/json",
                },
              })
              .then(() => {
                this.loading = false;
                this.$emit("reloadDataAdd");
                this.closeAddData();
              });
          }
        })
        .catch((error) => {
          if (error.response) {
            this.popTitle = error.response.data.errMessage;
            this.popDialog = true;
          }
        });
    },
    resetForm() {
      this.data = {
        name: "",
        email: "",
        passw: "",
        role_id: "",
        gudang_id: "",
      };
      this.listGudang = [];
    },
    closeAddData() {
      this.resetForm();
      this.$refs.form.resetValidation();
      this.$emit("closeAddDataDialog");
    },
    closePopDialog() {
      this.loading = false;
      this.popDialog = false;
    },
  },
};
</script>